<template>
  <div class="columns is-marginless is-multiline">
    <div class="column is-12">
      <b-field
        :label="label"
        custom-class="has-text-default">
        <b-select
          v-model="valueurIndiceSelected"
          @input="actionValeurIndiceChange"
          :disabled="disabled || disabledValeurIndice"
          expanded>
          <option :value="null"> {{ $t('ajoutEditContrat.indexation.personnalise') }} </option>
          <option
            v-for="item in indicesValeursList"
            :key="item.id"
            :value="item">
            {{ func.formatIndice(item.valeurIndice, item.dateReference) }}
            {{ trimestre(item) }}
          </option>
        </b-select>
      </b-field>
    </div>
    <div class="column is-6">
      <b-field :label="$t('indexation.edit.labelDateIndexation')">
        <b-datepicker
          v-model="dateIndice"
          @input="actionValeurChange"
          :disabled="disabled"
          :placeholder="$t('ajoutEditContrat.indexation.dateIndice')"
          icon="calendar-today"
          position="is-bottom-right"
          nearby-selectable-month-days
          show-week-number
          editable
        />
      </b-field>
    </div>
    <div class="column is-6">
      <b-field :label="$t('indexation.edit.labelValueIndexation')">
        <input-currency
          v-model="valeurIndice"
          @input="actionValeurChange"
          :disabled="disabled"
          :placeholder="$t('ajoutEditContrat.indexation.valeurIndice')"
          isNumber="true">
        </input-currency>
      </b-field>
    </div>
  </div>
</template>

<script>
import inputCurrency from '@/components/general/inputCurrency';
import { formatIndice } from '@/services/indexation/getItemIndicesValeurs';

export default {
  name: 'ContratEditIndexation',
  components: {
    inputCurrency,
  },
  props: {
    label: {
      type: String,
    },
    date: {
      type: Date,
    },
    valeur: {
      type: Number,
    },
    indiceSelected: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledValeurIndice: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valueurIndiceSelected: null,
      func: {
        formatIndice,
      },
    };
  },
  computed: {
    dateIndice: {
      get() {
        return this.date;
      },
      set(val) {
        this.$emit('update:date', val);
        this.$emit('valuechanges');
      },
    },
    valeurIndice: {
      get() {
        return this.valeur;
      },
      set(val) {
        this.$emit('update:valeur', val);
        this.$emit('valuechanges');
      },
    },
    indicesValeursList() {
      return this.indiceSelected?.indiceValeurs || [];
    },
  },
  watch: {
    indiceSelected: {
      handler() {
        const indice = this.indiceSelected;
        if (!indice) return;
        const indiceFormat = this.func.formatIndice(this.valeur, this.date);
        const find = indice.indiceValeurs
          .find(el => this.func.formatIndice(el.valeurIndice, el.dateReference) === indiceFormat);
        if (find) this.valueurIndiceSelected = find;
        else this.valueurIndiceSelected = null;
      },
      immediate: true,
    },
  },
  methods: {
    actionValeurChange() {
      this.valueurIndiceSelected = null;
    },
    actionValeurIndiceChange(val) {
      this.dateIndice = val ? new Date(val.dateReference) : null;
      this.valeurIndice = val?.valeurIndice || 0;
      this.$emit('valueurIndiceChange', val);
    },
    trimestre(indiceValeur) {
      const trimestre = indiceValeur?.trimestre;
      return trimestre ? ` (${trimestre})` : '';
    },
  },
};
</script>
